import { CompanyMappedBenefit } from '@/graphql/generated';

import { BenefitWithLabel } from './benefits';

/**
 * Order given benefits by percentage, or as fallback by approvals, alphabetical
 */
export const orderBenefits = (benefits: BenefitWithLabel[]): CompanyMappedBenefit[] => {
  return benefits.sort((a, b) => {
    if (!a.percentage || !b.percentage) return b.approvals - a.approvals;
    const topPercentage = b.percentage - a.percentage;
    return topPercentage !== 0 ? topPercentage : a.label.localeCompare(b.label);
  });
};

export const getFilteredList = (
  benefits: CompanyMappedBenefit[],
  isCollapsingEnabled: boolean,
  isExpanded: boolean
): CompanyMappedBenefit[] => {
  if (isCollapsingEnabled && isExpanded) return benefits;
  return benefits.slice(0, 5);
};
